import * as React from 'react';

interface IProps {
	className?: string;
}

export const CheckIcon: React.FC<IProps> = ({ className }) => {
	return (
		<svg className={className} viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg'>
			{/* Filled green circle */}
			<circle cx='50' cy='50' r='50' fill='#89C947' />
			{/* White checkmark */}
			<path
				d='M25 52L42 68L75 32'
				stroke='white'
				strokeWidth='8'
				strokeLinecap='round'
				strokeLinejoin='round'
				fill='none'
			/>
		</svg>
	);
};
